import { environmentVariables } from 'utils/environmentVariables';

const PET_CONFIG = {
  app: {
    name: 'PET | PuppySpot',
    description: 'Photo and Video Edition Tool',
    version: '0.1.0',
  },
  baseLayoutSettings: {
    mainHeaderHeight: 54,
  },
  login: {
    loginErrorMessage: 'Invalid username or password. Please try again',
    emptyUserName: 'Please type your username!',
    emptyPassword: 'Please type your password!',
    rememberMeExpirationDays: 5,
    userCredentialsCookieKey: 'pps_RememberMe',
  },
  listingView: {
    statuses: {
      approved: 'Approved',

      pendingReview: 'Pending Review',

      forwarded: 'Forwarded',

      inProgress: 'In Progress',

      pendingBreeder: 'Pending breeder',

      default: 'Not Defined',

      statusId: 5,
    },

    manualTransitionStatuses: {
      live: ['Hidden', 'Removed'],
      pendingApproval: ['Removed'],
      hidden: ['Removed'],
      removed: [],
      sold: [],
      created: ['Removed'],
    },
    manualTransitionModalTexts: {
      headerTex:
        "Please confirm this action by selecting the reason why it's being <REPLACE_STATUS>, followed by a brief explanation, and then clicking OK.",
    },
    manualTransitionConfirmation: {
      content:
        'This task will remain assigned to you until you decide to forward it, mark as pending breeder, approve it or finish it later.',
      contentRemoved:
        'This task is not assigned, you are still able to send messages to the breeder or leave notes',
      title: 'Status updated to',
    },
    pendingBreederConfirmation: {
      text: 'You can send messages to breeder or leave notes',
      textParent: 'Parent(s) was send to Pending Breeder',
    },
    pendingBreederModalTitle: 'Set as Pending Breeder',
    pendingBreederModalText:
      'Select if this status applies to the Puppy and add the reason accordingly.',
    pendingBreederAppliestTo: {
      thisPuppy: 'This Puppy',
      allOthers: 'All other puppies in this litter',
      sire: 'Sire',
      dam: 'Dam',
    },
    pendingBreederStatuses: {
      puppy: [13, 5],
      Parent: 8,
    },
    reassignModalTitle: 'Reassign',
    reassignModalText:
      'Select the team-member you want to assign this listing to.',
    reassignListingReason: {
      other: 16,
    },
    reassignParentsReason: {
      other: 9,
    },
    reassignedConfirmationTitle: 'Listing re-assigned',
    reassignedConfirmationText:
      'Press Stay to write messages, to read information about this listing, or Exit to go to the main page.',
    headerTitle: 'Puppy ID',
    listingStatusText: 'Listing status:',
    listingStatusTextStatuses: {
      pending: 'PENDING APPROVAL',
    },
    headerLabels: {
      breed: 'Breed:',
      color: 'Color:',
      markings: 'Markings:',
      gender: 'Gender:',
      weight: 'Weight:',
      dateOfBirth: 'Date Of Birth:',
      available: 'Available:',
      age: 'Age:',
      champion: 'Champion Bloodline:',
    },
    errorTitle: 'Something went wrong, please contact support',
    readOnlyStatuses: {
      listing: [5],
      workFlow: [5, 13],
    },
    message: {
      success: {
        saveData: 'Your changes have been saved successfully.',
      },
    },
    exitListingModalTitle: 'Exit',
    approval: {
      errors: {
        labels: {
          media: 'Media Approval Error',
          parents: 'Parents Approval Error',
          listing: 'Listing Approval Error',
        },
      },
    },
  },
  formats: {
    date: 'MMMM D, YYYY',
    dayDate: 'dddd, MMMM D YYYY',
  },
  common: {
    requestErrorMessage: 'Something went wrong please contact support',
    mediaBucketUrl: `${environmentVariables.REACT_APP_MEDIA_BUCKET_URL}/`,
    photoPeaUrl: 'https://www.photopea.com',
  },
  lists: {
    listsStatus: {
      available: {
        key: 'available',
        ids: [1, 2, 4],
      },
      unavailable: {
        key: 'unavailable',
        ids: [3, 5],
      },
      byuser: {
        key: 'byuser',
      },
      pendingBreeder: {
        key: 'pendingBreeder',
        ids: [5, 13],
      },
    },
    searchTypes: {
      text: 'text',
      number: 'number',
    },
  },
  cache: {
    content: 'content',
    counters: 'counters',
  },
  noteTypeId: {
    internal: 1,
    general: 2,
    featured: 3,
    alert: 4,
    specialBreeder: 5,
    circumstantialBreeder: 6,
    noteFromBreeder: 8,
    financingDeclined: 9,
    breederShipping: 10,
  },
  purebredBreedTypeId: 1,
  medicalDetailsMicrochipId: 6,
  otherNeurologicalStimulationDescriptionId: 6,
  validate: {
    message: {
      error: {
        dateavailable: 'Minimum 8 weeks after the birth date',
        litterBirthDate: {
          empty: 'Please select a valid date',
        },
      },
    },
  },
  listingStatus: {
    created: 1,
    live: 2,
    sold: 3,
    hidden: 4,
    removed: 5,
  },
  workflowStatusListings: {
    submitted: 1,
    approvalInProgress: 2,
    approved: 3,
    pendingWorkAcceptance: 4,
    postponed: 5,
    forwarded: 6,
    forwardReviewInProgress: 14,
  },
  workflowStatusParents: {
    submitted: 7,
    approvalInProgress: 8,
    approved: 9,
    pendingWorkAcceptance: 10,
    postponed: 11,
    forwarded: 12,
    forwardReviewInProgress: 13,
  },
};

export default PET_CONFIG;
